import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { DemandasId } from "../models/demandas-monitoramento.model";
import { DemandasMonitoramentoService } from "../services/demandas-monitoramento.service";

@Injectable({
  providedIn: 'root'
})
export class PreDemandaResolver implements Resolve<boolean> {

  constructor(private service: DemandasMonitoramentoService) { }

  private isAllQueryParamsEmpty(queryParams: any): boolean {
    for (const key in queryParams) {
      if (queryParams.hasOwnProperty(key) && queryParams[key] !== null && queryParams[key] !== '') {
        return false;
      }
    }
    return true;
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    
    let demandasId: DemandasId = {
      project_full_id: (this.isAllQueryParamsEmpty(route.queryParams) ? route.parent.parent.params.idProjeto : null),
      pf_action_analysis_id: route.queryParams["pf_action_analysis_id"],
      pf_action_id: route.queryParams["pf_action_id"],
      pf_analysis_id: route.queryParams["pf_analysis_id"],
      pf_critical_id: route.queryParams["pf_critical_id"],
      pf_ind_action_analysis_id: route.queryParams["pf_ind_action_analysis_id"],
      pf_ind_action_id: route.queryParams["pf_ind_action_id"],
      pf_ind_analysis_id: route.queryParams["pf_ind_analysis_id"],
      pf_ind_critical_id: route.queryParams["pf_ind_critical_id"],
      pf_indicator_id: route.queryParams["pf_indicator_id"],
      pf_prt_analysis_id: route.queryParams["pf_prt_analysis_id"],
      pf_prt_issue_action_analysis_id: route.queryParams["pf_prt_issue_action_analysis_id"],
      pf_prt_issue_action_id: route.queryParams["pf_prt_issue_action_id"],
      pf_prt_issue_critical_id: route.queryParams["pf_prt_issue_critical_id"],
      pf_prt_issue_id: route.queryParams["pf_prt_issue_id"],
      pf_indicator_pf_id: route.queryParams["pf_indicator_pf_id"],
      pf_prt_issue_pf_id: route.queryParams["pf_prt_issue_pf_id"],
      pf_prt_issue_critical_action_id: route.queryParams["pf_prt_issue_critical_action_id"],
      pf_prt_issue_critical_action_analysis_id: route.queryParams["pf_prt_issue_critical_action_analysis_id"],      
    };

    return this.service.preDemanda(demandasId);
  }
}